import 'magnific-popup';

/* Open Search */
$('#CloseSearch').on( "click", function() {
    $( '#headerSearch' ).removeClass('search--open');
});

/* FIX BODY */
$('#check').change(function(){
    $( 'body' ).toggleClass('menu-open');
});

/* MAIN MENU */
$(document).ready(function(){
    function menuNav() { 
        $(this).toggleClass('open');
    }

    $('.nav-link').keypress(function(e){
        if(e.which == 13) {
            $('.nav-link').each(function() {
                $(this).removeClass('open');
            });
            $(this).toggleClass('open');
        }
    });
    
    $('.nav-link').click(function(e){
        $('.nav-link').each(function() {
            $(this).removeClass('open');
        });
        $(this).toggleClass('open');
    });
});


/* SHOW BY BUTTON IN PRODUCT VIEW */
if ( $(".buy--sticky").length ) {
    $(window).scroll(function () {
        if ($(this).scrollTop()>420 && $(this).scrollTop() < ($('#trustElement').offset().top - 400)) {
            $('.buy--sticky').slideDown(160);
        } else {
            $('.buy--sticky').slideUp(160);
        }
    });
}

const countDIV = document.querySelectorAll(".counter");
const countDIVObserver = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
        if (entry.isIntersecting) {
            countUp();
        }
    },{});
});
countDIV.forEach(function (lazyBackground) {
    countDIVObserver.observe(lazyBackground);
});

$('[data-magnific]').bind('click.magnific', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const url = $(this).data('magnific');

    $.magnificPopup.open({
        items: {
            src: url
        },
        type: 'image',
        closeOnContentClick: true,
        fixedContentPos: true,
        mainClass: 'mfp-with-zoom'
    });
})

/* Article progress bar */
$(document).ready(function () {

    /* Article nav */
    const elSidebar = $('#Sidebar');
    if (elSidebar.length) {
        $(window).bind('scroll', function () {
            const scrollTop     = $(window).scrollTop();
            const elementOffset = elSidebar.offset().top;
            const distance      = elementOffset - scrollTop;

            (distance  <= 140 ) ?
                elSidebar.addClass('sidebar-sticked') :
                elSidebar.removeClass('sidebar-sticked');  
        });
    }

    const elArticleState = $('.article__state');
    if (elArticleState.length) {
        $(window).bind('scroll', function () {
            const scrollTop     = $(window).scrollTop();
            const elementOffset1 = elArticleState.offset().top;
            const distance1      = elementOffset1 - scrollTop;

            (distance1 <= 160 ) ?
                elArticleState.addClass('state-sticked') :
                elArticleState.removeClass('state-sticked');
            
        });
    }

    $('.anker__toggle').on('click', function (e) {
        $('.anker__nav').toggleClass('open');
        $(this).toggleClass('open');
        
        if ($(this).hasClass('open')) {
            $('.anker__link').each(function() {
                $(this).attr('tabindex',0);
            });
        } else {
            $('.anker__link').each(function() {
                $(this).attr('tabindex',-1);
            });
        }
    });

    $('.anker__item').on('click', function (e) {
        $('.anker__nav').toggleClass('open');
        $('.anker__toggle').toggleClass('open');
    });

    $('#check').change(function(){
        $( "body" ).toggleClass('menu-open');
    });

    $( ".nav-toggle" ).on( "click", function() {
        $(this).closest("li").toggleClass('open');
    }); 

    /**
     * Sticky Header
     */
    $(window).scroll(function () {
        const elStickyHeader = $('.sticky-header');
        const elProductAnchor = $('.productAnchor');
        const elBody = $('body');

        const scroll = Math.floor($(window).scrollTop());
    })

    var getMax = function () {
        return $(document).height() - $(window).height();
    }

    var getValue = function () {
        return $(window).scrollTop();
    }

    if ('max' in document.createElement('progress')) {
        var progressBar = $('progress');

        progressBar.attr({
            max: getMax()
        });

        $(document).on('scroll', function () {
            progressBar.attr({
                value: getValue()
            });
        });

        $(window).resize(function () {

            progressBar.attr({
                max: getMax(),
                value: getValue()
            });
        });
    } else {
        var progressBar = $('.progress-bar'),
            max = getMax(),
            value, width;

        var getWidth = function () {

            value = getValue();
            width = (value / max) * 100;
            width = width + '%';
            return width;
        }

        var setWidth = function () {
            progressBar.css({
                width: getWidth()
            });
        }

        $(document).on('scroll', setWidth);
        $(window).on('resize', function () {

            max = getMax();
            setWidth();
        });
    }

    /* scroll-to-top button */
    var back_to_top_button = ['<a href="" class="back-to-top" title="An den Seitenanfang springen"><span class="more-arrow"></span></a>'].join("");
    $("body").append(back_to_top_button)
    $(".back-to-top").hide();

    $(function () {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 300) {
                $('.back-to-top').show();
            } else {
                $('.back-to-top').hide();
            }
        });

        $('.back-to-top').click(function () {
            $('body,html').animate({
                scrollTop: 0
            }, 800);
            return false;
        });
    });
});

// JavaScript Document
$("#AssetsFilter input[type='checkbox']").change(function () {
    $('#Position').val($(document).scrollTop());
    $("#AssetsFilter").submit();
});
$("#AssetsFilterReset input[type='checkbox']").change(function () {
    $('#PositionReset').val($(document).scrollTop());
    $("#AssetsFilterReset").submit();
});

/* COUNTER */
function countUp() {
    $('.counter__number').each(function () {
        var $this = $(this);
        jQuery({ Counter: 0 }).animate({ Counter: $this.attr('data-stop') }, {
            duration: 1700,
            easing: 'swing',
            step: function (now) {
                $this.text(Math.ceil(now));
            }
        });
    });
}

var zoom = 0;
  $( "#up" ).on( "click", function() {
    if (zoom < 60) {
      $( ".article__editor p" ).css( "font-size", "+=10%" );
      $( ".article__editor h2" ).css( "font-size", "+=10%" );
      $( ".article__editor h3" ).css( "font-size", "+=10%" );
      $( ".article__editor h4" ).css( "font-size", "+=10%" );
      $( ".article__editor ul" ).css( "font-size", "+=10%" );
      zoom = zoom + 10;
    }
    if (zoom == 60) {
      $( "#up" ).addClass('inactive');
    }
    if (zoom == -10) {
      $( "#down" ).removeClass('inactive');
    }
  });
  
  $( "#down" ).on( "click", function() {
    if (zoom > -20) {
      $( ".article__editor p" ).css( "font-size", "-=10%" );
      $( ".article__editor h2" ).css( "font-size", "-=10%" );
      $( ".article__editor h3" ).css( "font-size", "-=10%" );
      $( ".article__editor h4" ).css( "font-size", "-=10%" );
      $( ".article__editor ul" ).css( "font-size", "-=10%" );
      zoom = zoom - 10;
    }
    if (zoom == -20) {
      $( "#down" ).addClass('inactive');
    }
    if (zoom == 50) {
      $( "#up" ).removeClass('inactive');
    }
  });
  $( "#reset" ).on( "click", function() {
    if (zoom != 0) {
      $( ".article__editor p" ).css('font-size', '');
      $( ".article__editor h2" ).css('font-size', '');
      $( ".article__editor h3" ).css('font-size', '');
      $( ".article__editor h4" ).css('font-size', '');
      $( ".article__editor ul" ).css('font-size', '');
      zoom = 0;
      $( "#down" ).removeClass('inactive');
      $( "#up" ).removeClass('inactive');
    }
  });



/* Gutenberg Styling */
$('.wp-block-table.is-style-checklist tbody tr td:first-child').on('click', function (e) {
    $(this).toggleClass('checked');
});

/* Breadcrumb */
// Create the defaults once
var pluginName = 'breadcrumbs',
    pluginCssBlock = '.' + pluginName,
    cssExpanded = pluginName + '_expanded',
    cssToggle = pluginName + '__toggle',
    cssOverflow = pluginName + '_overflow',
    defaults = {
        /*propertyName: "value"*/
    };

// The actual plugin constructor
function Plugin(element, options)
{
    this.element = element;
    this.$element = $(element);
    this.options = $.extend({}, defaults, options);
    this._defaults = defaults;
    this._name = pluginName;

    this.init();
}

Plugin.prototype = {

    init: function () {
        this.injectExpander(this.$element);
        this.checkOverflow();
        var self = this;

        var lazyResize = $.proxy(this.debounce(this.checkOverflow, 300), self);
        var lazyToggle = $.proxy(this.doToggle, self);
        this.$element.on('click.' + pluginName, '.' + cssToggle, lazyToggle);
        $(window).on('resize.' + pluginName, lazyResize);
    },

    isOverflowed: function (el) {
        // Determins if we have overflow
        return el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;
    },

    checkOverflow: function () {
        if (this.isOverflowed(this.element)) {
            this.$element.addClass(cssOverflow);
        } else {
            this.$element.removeClass(cssOverflow);
            // double check to make sure that that toggle is still valid
            if (this.isOverflowed(this.element)) {
                this.$element.addClass(cssOverflow);
            }
        }
    },

    doCollapse: function () {
        this.$element
            .addClass(cssExpanded);
    },

    doExpand: function () {
        this.$element
            .removeClass(cssExpanded);
    },

    doToggle: function (evt) {
        evt.preventDefault();
        var $el = this.$element;

        if ($el.hasClass(cssExpanded)) {
            this.doExpand();
        } else {
            this.doCollapse();
        }

    },

    injectExpander: function ($el) {
        if (!$el.has(cssToggle).length) {
            $el
                .children(':first')
                .after($('<li class="' + cssToggle + '"><a href="#"></a></li>'));
        }
    },

    debounce: function (func, wait, immediate) {
        var timeout, args, context, timestamp, result;

        var now = Date.now || function () {
            return new Date().getTime();
        };

        var later = function () {
            var last = now() - timestamp;

            if (last < wait && last >= 0) {
                timeout = setTimeout(later, wait - last);
            } else {
                timeout = null;
                if (!immediate) {
                    result = func.apply(context, args);
                    if (!timeout) {
                        context = args = null;
                    }
                }
            }
        };

        return function () {
            context = this;
            args = arguments;
            timestamp = now();
            var callNow = immediate && !timeout;
            if (!timeout) {
                timeout = setTimeout(later, wait);
            }
            if (callNow) {
                result = func.apply(context, args);
                context = args = null;
            }

            return result;
        };
    }
};

$.fn[pluginName] = function (options) {
    return this.each(function () {
        if (!$.data(this, 'plugin_' + pluginName)) {
            $.data(
                this,
                'plugin_' + pluginName,
                new Plugin(this, options)
            );
        }
    });
};

// AutoInit based on predefined class (.breadcrumbs). Remove if you don't want this
$(document).ready(function () {
    $(pluginCssBlock)[pluginName]();
});


import 'owl.carousel';
var owl = $('.owl-carousel');

owl.owlCarousel({
    items:3,
    loop:false,
    margin:32,
    nav:true,
    responsive: {
      0: {
        items: 1
      },
      300: {
        items: 1.3,
        center: true
      },
      768: {
        items: 1.5
      },
      1000: {
        items: 2
      },
      1200: {
        items: 3
      }
    }
});

$('.owl-carousel--experts').owlCarousel({
    loop: false,
    margin: 30,
    responsiveClass: true,
    responsive:{
        0:{
            items:1,
            margin: 15,
            stagePadding: 30,
            nav:false
        },
        576:{
            items:2,
            nav:false
        },
        1000:{
            items:4,
            nav:false,
            loop:false
        }
    }
});

$('.owl-carousel--bonus').owlCarousel({
    loop:false,
    margin: 30,
    responsiveClass: true,
    responsive:{
        0:{
            items:1,
            margin: 15,
            stagePadding: 50,
            nav:false
        },
        576:{
            items:2,
            nav:false
        },
        1000:{
            items:2,
            nav:true,
            loop:false
        }
    }
});


/* SHOW BY BUTTON IN PRODUCT VIEW */
if ( $(".buy--sticky").length ) {
    $(window).scroll(function () {
        if ($(this).scrollTop()>420 && $(this).scrollTop() < ($('#trustElement').offset().top - 400)) {
            $('.buy--sticky').slideDown(160);
        } else {
            $('.buy--sticky').slideUp(160);
        }
    });
}

/* CONTACT FORM */
 $("#ContactForm").submit(function ( event ) {
    var e_commit = '';
    var e_name = '';
    var e_mail = '';
    var e_nachricht = '';

    if ($("input[name=Commit]").is(':checked')) {
        $(".error_Commit").addClass("none");
        e_commit = '1';
    } else {
        $(".error_Commit").removeClass("none");
        e_commit = '0';
    }
    if ($("input[name=NameHoney]").val().length >= 3) {
        $(".error_NameHoney").addClass("none");
        $(".error_NameHoney").parent().closest('div').removeClass("error");
        e_name = '1';
    } else {
        $(".error_NameHoney").removeClass("none");
        $(".error_NameHoney").parent().closest('div').addClass("error");
        e_name = '0';
    }
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    var emailAdress = $("input[name=EmailHoney]").val();
    if (emailReg.test(emailAdress) && emailAdress != '') {
        $(".error_EmailHoney").addClass("none");
        $(".error_EmailHoney").parent().closest('div').removeClass("error");
        e_mail = '1';
    } else {
        $(".error_EmailHoney").removeClass("none");
        $(".error_EmailHoney").parent().closest('div').addClass("error");
        e_mail = '0';
    }
    if ($("textarea[name=Nachricht]").val().length >= 3 && $("textarea[name=Nachricht]").val() != 'Nachricht') {
        $(".error_Nachricht").addClass("none");
        $(".error_Nachricht").parent().closest('div').removeClass("error");
        e_nachricht = '1';
    } else {
        $(".error_Nachricht").removeClass("none");
        $(".error_Nachricht").parent().closest('div').addClass("error");
        e_nachricht = '0';
    }

    if (e_name === '1' && e_mail === '1' && e_nachricht === '1' && e_commit === '1') {
        return;
    }

    event.preventDefault();
 });
